import { Component, Input, OnInit } from '@angular/core';

import { Browser } from '@capacitor/browser';

@Component({
    selector: 'app-href',
    templateUrl: './href.component.html',
    styleUrls: ['./href.component.scss'],
    standalone: false
})
export class HrefComponent implements OnInit
{
	@Input() url: string;

	constructor() { }

	ngOnInit() { }

	async openUrl(ev: any)
	{
		ev.preventDefault();
		await Browser.open({ url: this.url });
	}

}
